export default "__VITE_ASSET__DSxM4rom__"